import {createReducer} from "@reduxjs/toolkit";
import {filtersFetched,filtersFetching,activeFilterChanged,filtersFetchingError} from "./action";

const initialState = {
    filters:[],
    filteredLoading:'false',
    activeFilter:'all',
}
// export const filter = (state=initialState,action)=>{
//     switch (action.type){
//         case "FILTER_FETCHING":
//             return {
//                 ...state,
//                 filteredLoading: 'true'
//             }
//         case "FILTERS_FETCHED":
//             return {
//                 ...state,
//                 filters: action.payload,
//                 filteredLoading: 'false'
//             }
//         case "FILTERS_FETCHED_ERROR":
//             return {
//                 ...state,
//                 filteredLoading: "false"
//             }
//         case "ACTIVE_FILTER_CHANGED":
//             return {
//                 ...state,
//                 activeFilter: action.payload,
//             }
//         default:
//             return state
//     }
// }



 export  const filter = createReducer(initialState,{
    [filtersFetching]: state=>{state.filteredLoading ='true'},
    [filtersFetched]:(state,action)=>{
        state.filteredLoading='false';
        state.filters = action.payload
    },
         [filtersFetchingError]:state=>{state.filteredLoading='false'},
         [activeFilterChanged]:(state,action)=>{state.activeFilter=action.payload}
},[],state => state
)